import AdminSidebar from "../Components/AdminSidebar/adminSidebar";
import AdminMainContainers from "../Containers/AdminMainContainers";

const AdminMainPage = () => {

    return (
        <>
            <AdminSidebar />
            <AdminMainContainers />
        </>
    )
}
export default AdminMainPage;
